import { Component, OnInit, ViewChild, EventEmitter, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { detailExpand } from '../../shared-components/angular-material/mat-animations';
import { TylerMatTableDataSource } from '../../shared-components/angular-material/extended.class';
import { Subscription } from 'rxjs';
import { EFormService } from '../../shared-components/e-forms/e-form.service';
import { LoginService } from '../../shared-modules/login/login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TabsComponent } from '../../shared-components/controls/tabs/tabs.component';
import { EFormDataObject } from '../../shared-components/e-forms/e-formDataObject.model';
import { EForm } from '../../shared-components/e-forms/e-form.model';
import { YearService } from '../../shared-components/year/year.service';
import * as moment from 'moment';
import { EFormSelectStudentDialogComponent } from './e-form-select-student-dialog/e-form-select-student-dialog.component';
import { Student } from '../../shared-components/student/student.model';
import * as _ from 'lodash';
import { GeneralConfirmationComponent } from '../../shared-components/controls/general-confirmation/general-confirmation.component';
import { UserService } from '../../shared-components/user/user.service';
import { EFormUnfinishedDialogComponent } from './e-form-unfinished-dialog/e-form-unfinished-dialog.component';
import { EFormConfiguration, enmEFormViewModes } from '../../shared-components/e-forms/e-form-config.model';
import { EFormViewerModalComponent } from '../../shared-components/e-forms/e-form-viewer/e-form-viewer-modal/e-form-viewer-modal.component';
import { System } from '../../shared-components/System';
import { EFormCriticalMessageDialogComponent } from './e-form-critical-message-dialog/e-form-critical-message-dialog.component';
import { UserPermission } from '../../shared-components/user/user-permission.model';
import { PermissionEnum } from '../../shared-components/security/permissions.enums';
import { StudentService } from '../../shared-components/student/student.service';
import { EFormSelectYearDialogComponent } from './e-form-select-year-dialog/e-form-select-year-dialog.component';
import { Year } from '../../shared-components/year/year.model';

@Component({
    selector: 'e-forms',
    templateUrl: './e-forms.component.html',
    styleUrls: ['./e-forms.component.scss'],
    animations: [detailExpand],
})
export class EFormsComponent implements OnInit, AfterViewInit {

    // @ViewChild(MatSort) sort: MatSort;
    dataSource: TylerMatTableDataSource = new TylerMatTableDataSource();
    @ViewChild(MatSort) set matSort(sort: MatSort) { this.dataSource.sort = sort; }
    columnsToDisplay = ['Year', 'InstanceName', 'TemplateType', 'Student', 'DueDate', 'SubmittedDate', 'SubmittedName', 'Status'];
    subscriptions: Subscription[] = [];
    showCompleted: boolean;
    pastYear: boolean;
    V10: boolean;
    currentDateString: string;
    staffPage = false;
    eFormPermissions: UserPermission[] = [];
    showYearSelector = true;
    years: Year[] = [];

    eForms: EForm[];
    filteredEForms: EForm[];

    tabNames: string[] = ['REQUIRED', 'OPTIONAL'];
    selectionIndex = 0;
    reSelectStudent: boolean;
    userType: number;
    holdReqTabFilters: any[];
    holdOptTabFilters: any[];
    setIndex = new EventEmitter<number>();
    @ViewChild(TabsComponent, { static: true }) tabs: TabsComponent;

    constructor(
        private eFormService: EFormService,
        private dialog: MatDialog,
        private loginService: LoginService,
        private router: Router,
        private yearService: YearService,
        private userService: UserService,
        private route: ActivatedRoute,
        private studentService: StudentService
    ) {

    }

    ngOnInit() {
        this.V10 = this.loginService.LoginSettings.V10;
        if (!this.V10) {
            this.columnsToDisplay = ['Year', 'InstanceName', 'TemplateType', 'Student', 'DueDate', 'SubmittedOn', 'SubmittedName', 'Status'];
        }
        this.currentDateString = moment().format('MM/DD/YY');
        this.staffPage = this.route.snapshot.paramMap.get('staffPage') == ':staffPage';

        if (this.userService.userType == 1) {
            this.getEFormPermissions();
            this.showYearSelector = false;
        }
        else {
            this.getEForms();
        }

        this.subscriptions.push(
            this.yearService.observableStudent360YearStream$.subscribe(() => {
                this.getEForms();
            }),
        );
        // ************ When selected student will change ************
        this.subscriptions.push(this.studentService.observableStudentEnrollmentStream$.subscribe(enrollment => {
            if (enrollment) {
                // this.studentService.selectedStudent.Id = enrollment.StudentId;
                if (this.reSelectStudent) {
                    this.getEForms();
                }
            }
        }));
        // ************ ********************************** ************

        if (this.staffPage) {
            this.removeElement(this.columnsToDisplay, 'TemplateType');
            this.removeElement(this.columnsToDisplay, 'Student');
            this.showYearSelector = false;
        }

        this.dataSource.sortingDataAccessor = (eForm: EForm, property: string) => {
            switch (property) {
                case 'InstanceName':
                    if (eForm.AllowMultiple && eForm.ID != 0) {
                        return (eForm.InstanceName + ' ').toLocaleLowerCase();
                    }
                    else {
                        return eForm.InstanceName.toLocaleLowerCase();
                    }
                case 'Status':
                    return (eForm.Status).toLocaleLowerCase();
                case 'Year':
                    if (this.V10) {
                        return eForm.AYIdentifier ? (eForm.AYIdentifier).toLocaleLowerCase() : '';
                    }
                    else {
                        let year: Year = this.yearService.allYears.find(year => year.Id == eForm.Year_ID);
                        return (eForm.ShowInAllYears == true && !eForm.ID) ? 'Multiple' : (year ? year.Description : '');
                    }
                default:
                    // return eForm[property];
                    if (eForm[property] || eForm[property] == '') {
                        return this.dataSource.defaultSortingAccessor(eForm, property);
                    }
            }
        };
        this.userType = this.userService.userType;
    }

    ngAfterViewInit() {
        if (this.eFormService.initialS360eFormTab != '') {
            if (this.eFormService.initialS360eFormTab == 'optional') {
                const tabIndex = this.tabNames.indexOf('OPTIONAL');
                this.setIndex.emit(tabIndex);
            }

            this.eFormService.initialS360eFormTab = '';
            // this.dataSource.sort = this.sort;
        }
    }

    getEForms() {
        this.reSelectStudent = true;

        if (this.staffPage) {
            this.eFormService.getStaffUserEformsByLoginId().subscribe(result => {
                this.eForms = result;
                if (!this.V10) {
                    for (let i = 0; i < this.eForms.length; i++) {
                        if (!this.eForms[i].ID || this.eForms[i].ID == 0) {
                            this.eForms[i].Status = '';
                        }
                    }
                }
                this.loadTable();
            });
        }
        else {
            this.eFormService.getStudentParentEforms().subscribe(result => {
                this.eForms = result;
                if (!this.V10) {
                    for (let i = 0; i < this.eForms.length; i++) {
                        if (!this.eForms[i].ID || this.eForms[i].ID == 0) {
                            this.eForms[i].Status = '';
                        }
                    }
                }
                this.loadTable();
            });
        }
    }

    tabChange(e: any) {

    }

    getEFormPermissions() {
        this.eFormPermissions = this.eFormService.eFormPermissions;
        if (!this.eFormPermissions || this.eFormPermissions.length == 0) {
            this.subscriptions.push(this.eFormService.getEformPermissions(this.yearService.defaultYear.Id).subscribe(result => {
                this.eFormPermissions = result;
                this.eFormService.eFormPermissions = result;
                this.getEForms();
            }));
        }
        else {
            this.getEForms();
        }
    }

    loadTable() {
        this.filteredEForms = this.eForms;
        if (this.filteredEForms) {
            if (this.userService.userType != 1 || (!this.staffPage && this.eFormPermissions.find(o => o.PrivilegeId == PermissionEnum.eFormCompleteAllStudentForms) == null)) {

                this.filteredEForms = this.filteredEForms.filter(eForm =>
                    //  Students
                    ((eForm.StudentsCanComplete) && this.userService.userType == 3) ||
                    //  Parents
                    ((eForm.ParentsCanComplete) && this.userService.userType == 2) ||
                    //  Staff
                    ((eForm.StaffCanComplete || (eForm.TemplateType != null && eForm.TemplateType.toLowerCase() == 'staff')) && this.userService.userType == 1)
                );
            }

            this.filteredEForms = this.filteredEForms.filter(eForm =>
            ((eForm.Required && this.selectionIndex == 0) ||            // required tab selected
                (!eForm.Required && this.selectionIndex == 1))              // optional tab selected
            );


            if (!this.showCompleted) {
                this.filteredEForms = this.filteredEForms.filter(eForm =>
                    (eForm.Status != null && eForm.Status.toLowerCase() != 'complete')                 // hide completed when checkbox not checked
                );

                if (!this.V10) {
                    this.filteredEForms = this.filteredEForms.filter(eForm =>
                        ((eForm.IsInstanceActive != null && eForm.IsInstanceActive.toLowerCase() == 'active') || (eForm.Status != null && eForm.Status.toLowerCase() == 'accepted'))               // Push only active Instances when checkbox not checked
                    );
                }
            }
            else if (!this.V10) {
                this.filteredEForms = this.filteredEForms.filter(eForm =>
                    ((eForm.IsInstanceActive != null && eForm.IsInstanceActive.toLowerCase() == 'active') || (eForm.Status != null && eForm.Status.toLowerCase() == 'complete') || (eForm.Status != null && eForm.Status.toLowerCase() == 'accepted'))                 // Push only active Instances when checkbox not checked
                );
            }

            if (this.pastYear && this.yearService.student360Year.Status != 2) {
                // if (this.yearService.student360Year.Status == 2 && !this.V10) {
                //     this.dataSource.data = this.filteredEForms;
                // }
                // else {
                this.filteredEForms = this.filteredEForms.filter(eForm =>
                    ((eForm.Status != null && eForm.Status.toLowerCase() != 'not submitted') // hide not submitted when past year selected in year drop down
                        && eForm.Status != ''
                        && eForm.Status.toLocaleLowerCase() != 'rejected'
                    ) && (!eForm.AllowMultiple || eForm.ID != 0)                     // hide Multi Use forms when past year selected in year drop down
                );
                // }

                this.dataSource.data = this.filteredEForms;
            }
            else {
                let tempFilteredEForms = this.filteredEForms;
                tempFilteredEForms = [];

                for (let n = 0; n < this.filteredEForms.length; n++) {
                    const CurrentDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
                    const StartDate: Date = new Date(new Date(this.filteredEForms[n].StartDate).getFullYear(), new Date(this.filteredEForms[n].StartDate).getMonth(), new Date(this.filteredEForms[n].StartDate).getDate());
                    const EndDate: Date = new Date(new Date(this.filteredEForms[n].EndDate).getFullYear(), new Date(this.filteredEForms[n].EndDate).getMonth(), new Date(this.filteredEForms[n].EndDate).getDate());
                    let flag = 0;
                    if ((this.filteredEForms[n].StartDate == undefined || this.filteredEForms[n].StartDate == null
                        || CurrentDate >= StartDate)
                        && (this.filteredEForms[n].EndDate == undefined
                            || this.filteredEForms[n].EndDate == null
                            || CurrentDate <= EndDate)) {
                        flag++;
                    }
                    if (this.statusDateOverrideCheck(this.filteredEForms[n].Status) || flag > 0) {
                        tempFilteredEForms.push(this.filteredEForms[n]);
                    }
                }
                if (tempFilteredEForms.length) {
                    this.filteredEForms = tempFilteredEForms;
                    this.dataSource.data = this.filteredEForms;
                }
                else {
                    this.dataSource.data = [];
                }
                if (!this.V10) {
                    if (this.selectionIndex == 0 && this.holdReqTabFilters && this.holdReqTabFilters.length > 0) {
                        this.dataSource.filters = this.holdReqTabFilters;
                    }
                    if (this.selectionIndex == 1 && this.holdOptTabFilters && this.holdOptTabFilters.length > 0) {
                        this.dataSource.filters = this.holdOptTabFilters;
                    }
                }
            }
            // this.dataSource.data =  this.filteredEForms;
        }
    }

    statusDateOverrideCheck(status: string): boolean {
        switch (status != null && status.toLowerCase()) {
            case 'approved':
            case 'rejected':
            case 'complete':
            case 'completed':
            case 'deleted': {
                return true;
            }
            default: {
                return false;
            }
        }
    }

    selectionChange(selectionIndex: number) {
        if (this.selectionIndex == 0) {
            this.holdReqTabFilters = _.cloneDeep(this.dataSource.filters);
        }
        if (this.selectionIndex == 1) {
            this.holdOptTabFilters = _.cloneDeep(this.dataSource.filters);
        }
        this.dataSource.filters = [];
        this.selectionIndex = selectionIndex;
        this.loadTable();
    }

    showCompletedChange() {
        setTimeout(() => {
            this.loadTable();
        }, 0);
    }

    dueDateCheck(row: EForm): string {
        let highlight = '';

        if (row.CompletionDue && ((row.Status == '' && row.ID == 0) || (row.Status != null && row.Status.toLowerCase() == 'not submitted') || (row.Status != null && row.Status.toLowerCase() == 'rejected'))) {

            switch (row.CompletionDueOption != null && row.CompletionDueOption.toLowerCase()) {
                case 'dueby':
                    if (row.DueDate) {
                        const dueDate: moment.Moment = moment(row.DueDate);

                        if (dueDate.isBefore(moment.now())) {
                            highlight = 'red-bold-due';
                        }
                        else if (dueDate.subtract(3, 'days').isBefore(moment.now())) {
                            highlight = 'red-due';
                        }
                        else if (dueDate.subtract(7, 'days').isBefore(moment.now())) {
                            highlight = 'orange-due';
                        }
                    }
                    break;
                case 'onceper':
                    if (row.Frequency != null && row.Frequency.toLowerCase() == 'day' && row.Required) {
                        highlight = 'red-bold-due';
                    }
                    break;
            }
        }

        return highlight;
    }

    pastDueCheck(row: EForm): boolean {
        let result = false;

        if (row.CompletionDue && row.CompletionDueOption && ((row.Status == '' && row.ID == 0) || (row.Status != null && row.Status.toLowerCase() == 'not submitted') || (row.Status != null && row.Status.toLowerCase() == 'rejected'))) {

            switch (row.CompletionDueOption != null && row.CompletionDueOption.toLowerCase()) {
                case 'dueby':
                    if (row.DueDate) {
                        const dueDate: moment.Moment = moment(row.DueDate);

                        result = dueDate.isBefore(moment.now());
                    }
                    break;
                case 'onceper':
                    if (row.Frequency != null && row.Frequency.toLowerCase() == 'day' && row.Required) {
                        result = true;
                    }
                    break;
            }
        }

        return result;
    }

    formClick(eForm: EForm) {
        if (!this.V10 && eForm.Non_English && eForm.Status != null && eForm.Status.toLowerCase() != 'not submitted') {
            this.getFormDataByInstanceId('View - Translated', eForm);
        } else {
            this.eFormService.populateFormData(eForm).subscribe((populatedEForm: EForm) => {
                if (populatedEForm) {
                    eForm = populatedEForm;
                }
                eForm.FormData = eForm.FormData.replace('<<student', '<<Student');
                eForm.FormData = eForm.FormData.replace('&lt;&lt;student', '&lt;&lt;Student');
                if (eForm.ManualSubmission) {
                    const manualSubmissionDialog = this.dialog.open(GeneralConfirmationComponent, {
                        disableClose: true,
                    });
                    manualSubmissionDialog.componentInstance.informational = true;
                    manualSubmissionDialog.componentInstance.headerLabel = 'Manual Submission';
                    manualSubmissionDialog.componentInstance.confirmMessage = 'This form was manually submitted so is not available for online viewing.';
                }
                else if (eForm.AllowMultiple && !eForm.ID && eForm.TemplateType != 'family') {
                    if (this.userService.userType != 1) {
                        this.subscriptions.push(this.eFormService.getEFormStudentsByInstanceId(this.yearService.student360Year.Id, this.yearService.student360Year.SchoolID, eForm.Instance_ID).subscribe(students => {
                            let distinctStudents: Student[] = [];

                            if (students) {
                                students.forEach(student => {
                                    if (distinctStudents.findIndex(o => o.Id == student.Id) == -1) {
                                        distinctStudents.push(student);
                                    }
                                });
                            }

                            if (distinctStudents.length == 1) {
                                const newForm = _.cloneDeep(eForm);
                                newForm.Student_ID = distinctStudents[0].Id;
                                newForm.Family_ID = distinctStudents[0].FamilyId;
                                if (newForm.ShowInAllYears && newForm.AllowMultiple) {
                                    this.shouldShowSelectYearDialog(newForm);
                                }
                                else {
                                    this.openFormViewer(newForm);
                                }
                            }
                            else {
                                distinctStudents = distinctStudents.sort((a, b) => {
                                    if (a.FirstName.toLowerCase() + a.LastName.toLowerCase() < b.FirstName.toLowerCase() + a.LastName.toLowerCase()) { return -1; }
                                    if (a.FirstName.toLowerCase() + a.LastName.toLowerCase() > b.FirstName.toLowerCase() + a.LastName.toLowerCase()) { return 1; }
                                });

                                this.openStudentSelector(eForm, distinctStudents);
                            }
                        }));
                    }
                    else {
                        const newForm: EForm = _.cloneDeep(eForm);
                        if (!this.staffPage) {
                            newForm.Student_ID = this.studentService.selectedStudent.Id;
                            newForm.Family_ID = this.studentService.selectedStudent.FamilyId;
                        }
                        this.openFormViewer(newForm);
                    }
                }
                else {
                    // this.openFormViewer(eForm);
                    this.checkForUnfinished(eForm);
                }
            });
        }
    }

    getFormDataByInstanceId(actionName: string, eForm: EForm) {
        this.eFormService.getFormDataByInstanceId(this.yearService.defaultYear.Id, eForm.ID, [eForm.Instance_ID]).subscribe(result => {
            eForm.FormData = result[0].FormData;
            if (actionName == 'View - Translated') {
                this.action_View_Translated(result[0].TranslatedPDF, eForm.InstanceName);
            }
        });
    }
    action_View_Translated(TranslatedPDF64, InstanceName) {
        System.viewFileFromBase(TranslatedPDF64, 'application/pdf', InstanceName);
    }

    checkForUnfinished(eForm: EForm) {
        if (eForm.ID > 0 && eForm.Status != null && eForm.Status.toLowerCase() == 'not submitted' && !eForm.IsLastStatusDelete) {
            const eFormUnfinishedDialog = this.dialog.open(EFormUnfinishedDialogComponent, {
                disableClose: true,
                data: {
                    Form: eForm
                }
            });

            eFormUnfinishedDialog.afterClosed().subscribe(result => {
                if (result == 'StartOver') {
                    this.eFormService.getEFormInstance(eForm.Instance_ID).subscribe(instance => {
                        const newEForm: EForm = _.cloneDeep(eForm);
                        newEForm.FormData = instance.FormData;
                        this.openFormViewer(newEForm);
                    });
                }
                else if (result == 'Continue') {
                    this.openFormViewer(eForm);
                }
            });
        }
        else {
            if (eForm.IsLastStatusDelete) {
                this.eFormService.getEFormInstance(eForm.Instance_ID).subscribe(instance => {
                    const newEForm: EForm = _.cloneDeep(eForm);
                    newEForm.FormData = instance.FormData;
                    this.openFormViewer(newEForm);
                });
            }
            else {
                if (eForm.ShowInAllYears && eForm.AllowMultiple && eForm.ID <= 0) {
                    this.shouldShowSelectYearDialog(eForm);
                }
                else {
                    this.openFormViewer(eForm);
                }
            }
        }
    }

    openFormViewer(eForm: EForm) {
        this.subscriptions.push(this.eFormService.markInstanceAsViewed(eForm.Instance_ID).subscribe(() => { }));
        this.eFormService.selectedForm = eForm;
        try {
            this.eFormService.selectedFormData = JSON.parse(eForm.FormData);
        } catch (err) {
            this.eFormService.selectedFormData = new EFormDataObject();
        }
        this.subscriptions.push(this.eFormService.getEFormInstance(eForm.Instance_ID).subscribe(instance => {
            const config = new EFormConfiguration();
            config.ViewMode = enmEFormViewModes.Form;
            config.Title = instance ? instance.Name : '';
            config.ReadOnly = (eForm.Status != null && (eForm.Status.toLowerCase() == 'submitted' || eForm.Status.toLowerCase() == 'accepted' || eForm.Status.toLowerCase() == 'complete'));
            config.AllowInstanceSpecificText = true;
            config.NewForm = !eForm.ID || eForm.ID <= 0;
            if (config.ReadOnly && eForm.TranslatedPDF) {
                let formName: string = instance.Name;
                if (instance.TemplateType != null && instance.TemplateType.toLowerCase() == 'student') {
                    formName += eForm.Student;
                }
                System.saveFile(eForm.TranslatedPDF, 'pdf', formName + '.pdf');
            }
            else {
                const viewFormDialog = this.dialog.open(EFormViewerModalComponent, {
                    disableClose: true,
                    height: '100vh',
                    data: {
                        config: config
                    }
                });
                this.subscriptions.push(viewFormDialog.afterClosed().subscribe(action => {
                    if (this.eFormService.showCriticalMessage) {
                        const eFormCMDialog = this.dialog.open(EFormCriticalMessageDialogComponent, {
                            disableClose: true,
                            width: '700px',
                            data: {
                                message: eForm.CriticalMessage
                            }
                        });

                        this.subscriptions.push(eFormCMDialog.afterClosed().subscribe(() => {
                            this.getEForms();
                        }));
                    }
                    else if (action == 'rerouteToFeesAfterSubmit') {
                        this.router.navigateByUrl('/student360/feesAndBilling');
                    }
                    else {
                        this.getEForms();
                    }
                }));
            }
        }));
    }

    openStudentSelector(eForm: EForm, students: Student[]) {
        const selectStudentDialog = this.dialog.open(EFormSelectStudentDialogComponent, {
            disableClose: true,
            data: {
                Form: eForm,
                Students: students
            }
        });
        this.subscriptions.push(selectStudentDialog.afterClosed().subscribe((newForm: EForm) => {
            if (newForm) {
                if (newForm.ShowInAllYears && newForm.AllowMultiple) {
                    this.shouldShowSelectYearDialog(newForm);
                }
                else {
                    this.openFormViewer(newForm);
                }
            }
        }));
    }

    private shouldShowSelectYearDialog(form: EForm) {
        this.yearService.getUserYears(this.userService.userId, this.userService.userType, form.Student_ID).subscribe(y => {
            this.years = _.cloneDeep(y.filter(o => o.SchoolID == this.yearService.student360Year.SchoolID && o.Disabled == false));
            this.years = this.years.filter(year => moment(year.StartDate).isSameOrAfter(this.yearService.defaultYear.StartDate));
            if (this.userService.currentUser.UserType == 1) {
                // current user is staff
                this.years = _.cloneDeep(this.yearService.yearsForC360);
            }
            else if (this.loginService.LoginSettings.V10) {
                this.years = _.cloneDeep(this.studentService.enrollmentYears);
            }
            if (this.years.length != 1) {
                // Only show year selector dialog if there's more than one year to choose
                this.openYearSelector(form, this.years);
            }
            else {
                // Only one year, skip year selector dialog
                if (!this.V10) {
                    form.Year_ID = this.years[0].Id;
                }
                this.openFormViewer(form);
            }
        });
    }

    openYearSelector(eForm: EForm, years: Year[]) {
        const selectYearDialog = this.dialog.open(EFormSelectYearDialogComponent, {
            disableClose: true,
            data: {
                Form: eForm,
                years: years
            }
        });
        this.subscriptions.push(selectYearDialog.afterClosed().subscribe((newForm: EForm) => {
            if (newForm) {
                this.openFormViewer(newForm);
            }
        }));
    }

    toggleExpanded(row: any) {
        this.dataSource.toggleExpanded(row);
    }

    checkExpanded(row: any): boolean {
        return this.dataSource.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        this.dataSource.expandAll(expand);
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        this.dataSource.rowKeyPress(event, row);
    }

    removeElement(array: any[], element: any) {
        const index: number = array.indexOf(element);
        if (index != -1) {
            array.splice(index, 1);
        }
    }
}
